import React from "react";

import CommentThread from "./CommentThread";
import LineThread from "./LineThread";
import "../../../css/admin/comments.scss";

import type { JSX } from "react";

import type { CommentSource, DetailedComment } from "../comment.types";

interface CommentsThreadProps {
  item?: DetailedComment | null;
}

function CommentsThread({ item }: CommentsThreadProps): JSX.Element | null {
  if (!item) return null;

  let source: CommentSource | undefined;

  if (item.media) {
    source = {
      ...item.media,
      sourceType: "content",
    };
  } else if (item.smartlist) {
    source = {
      ...item.smartlist,
      sourceType: "smartlists",
    };
  }

  return (
    <div className="editor-comments-thread-view-container">
      <CommentThread
        main
        source={source}
        text={item.comment}
        user={item.user}
      />
      {item.comment_abuses?.map((report) => (
        <div key={report.comment_uuid} className="report-comment">
          <LineThread icon="flag" insertedAt={report.inserted_at} />
          <CommentThread
            main={false}
            text={report.message}
            user={report.user}
          />
        </div>
      ))}
    </div>
  );
}

export default CommentsThread;
